// extracted by mini-css-extract-plugin
export var infoRow = "_uh-2";
export var labelContainer = "_uh-0";
export var rightInfo = "_uh-1";